import { render, staticRenderFns } from "./LotStatus.vue?vue&type=template&id=64a8fe61&scoped=true&"
import script from "./LotStatus.vue?vue&type=script&lang=js&"
export * from "./LotStatus.vue?vue&type=script&lang=js&"
import style0 from "./LotStatus.vue?vue&type=style&index=0&id=64a8fe61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a8fe61",
  null
  
)

export default component.exports